<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records upload-dna-section">
            <div class="row h-100">
                <div class="col-12 mb-4 h-100">
                    <div class="bg-white border-radius-5 p-3 h-100">
                        <div class="row justify-content-center p-4">
                            <div class="col-lg-9 text-center">
                                <div class="Code-scanner d-flex border-radius-8 mb-4 p-4">
                                    <figure class="mb-0 mr-4"><img src="../../../../static/website/images/qr-scanner.png" alt="" /></figure>
                                    <div class="scan text-left">
                                        <h3>Scan OR code Instead</h3>
                                        <p class="mb-4">Scan this OR code using your mobile camera or OR code app</p>
                                        <div class="d-flex justify-content-between">
                                            <figure class="mb-0 mr-3"><img src="../../../../static/website/images/scan-info.svg" alt="" /></figure>
                                            <p class="text-left mb-0">Please Keep this page while you can using your mobile</p>
                                        </div>
                                    </div>
                                </div>
                                <router-link to="/upload-test-reports" class="btn btn-blue Browser">Continue with Browser</router-link >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "Qr-code-prescription",
        data() {
            return {};
        },
        created(){
           this.pageName('DQR Code Screaner')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/Qr-code-prescription.vue